module.exports = __webpack_public_path__ + "static/shoe-1-b4cd23f67fa4c7437ecf31bb482049a3.png";